module.exports = __webpack_public_path__ + "img/empty.83fc876b.png";